import React from 'react';
import { Garage } from '@1po/1po-bff-fe-spec/generated/garage/Garage';
import { View } from '@react-pdf/renderer';
import { Card, Divider, ItemNameTitle, TextMid } from 'components/Pdf/PdfUI';
import { styles } from 'components/Pdf/PdfUI.styles';
import { getFirstValidAddress } from 'domains/garage/Garage.utils';
import { theme } from 'styles';
import { OrderPdfText } from './MyOrdersDetailPdfPage';

const ContactRow = ({ isLastElement, data }: { isLastElement: boolean; data: string | undefined }) => {
  if (!data) {
    return null;
  }
  return (
    <>
      <View style={[styles.col, { width: '100%', height: 20, justifyContent: 'center', padding: '0 5px' }]}>
        <TextMid>{data}</TextMid>
      </View>
      {!isLastElement && <Divider />}
    </>
  );
};

export const OrderContactCard = ({ text, garageInfo }: { text: OrderPdfText; garageInfo: Garage | undefined }) => {
  const address = garageInfo ? getFirstValidAddress(garageInfo) : undefined;

  const items = [garageInfo?.name, address?.phone, address?.email];

  return (
    <Card
      title={<ItemNameTitle>{text.contactSection}</ItemNameTitle>}
      height={100}
      width={200}
      noPadding
      titleBackgroundColor={theme.color.primary_brand_bg}
    >
      <View style={[styles.col]}>
        {items.map((data, index) => (
          <ContactRow isLastElement={index === items.length - 1} key={data} data={data} />
        ))}
      </View>
    </Card>
  );
};
